<template>
  <activity-dashboard :only-mine="true" />
</template>

<script>
import ActivityDashboard from './ActivityDashboard.vue'

export default {
  name: 'MyActivityPage',
  components: { ActivityDashboard }
}
</script>
